export class Constants{

    public static get ITEM_KEY_UPLOAD_RING():string { return "upload"; }
    public static get ITEM_KEY_DELETE_SPONGE():string { return "post delete"; }
    public static get ITEM_KEY_VARNISH():string { return "varnish powder"; }      

}